import { tsUtils } from '@neo-one/ts-utils';
import { BuiltinMemberCall } from '../BuiltinMemberCall';
export class SymbolFor extends BuiltinMemberCall {
    emitCall(sb, _func, node, options) {
        if (tsUtils.argumented.getArguments(node).length < 1) {
            return;
        }
        const arg = tsUtils.argumented.getArguments(node)[0];
        sb.visit(arg, sb.pushValueOptions(options));
        sb.emitHelper(arg, sb.pushValueOptions(options), sb.helpers.toString({ type: sb.context.analysis.getType(arg) }));
        sb.emitHelper(node, options, sb.helpers.wrapSymbol);
    }
}

//# sourceMappingURL=for.js.map
